import i18n from "@/lang";

export default function setRouteTitle({ to }) {
  const isRevGatePartner = process.env.VUE_APP_NAME === "revgate"
  const title = isRevGatePartner ? "RevGate" : "Boostiny"

  if (to.meta && to.meta.title) {
    document.title = `${title} - ${i18n.messages[i18n.locale].titles[to.meta.title] || to.name}`;
  } else {
    document.title = `${title} - ${to.name}`;
  }
}
